import { Component, OnInit, ViewChild } from '@angular/core';
import { Settings } from '../../../services/settings';
import { GeneralSetting } from '../../../models/generalsetting';
import { UserService } from '../../../services/user.service';
import { GlobalService } from '../../../services/global.service';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MessageBoxComponent } from "../../../components/message-box/message-box.component";

@Component({
	selector: 'app-emailsettings',
	templateUrl: './emailsettings.component.html',
	styleUrls: ['./emailsettings.component.css']
})
export class EmailsettingsComponent implements OnInit {

	formTitle = 'Email Settings';
	displaySavedMessage = false;
	valSMTPHost: any;
	valSMTPPort: any;
	valSMTPUsername: any;
	valSMTPPassword: any;
	valEnableEmail = false;
	smtpHostSetting: GeneralSetting;
	smtpPortSetting: GeneralSetting;
	smtpUsernameSetting: GeneralSetting;
	smtpPasswordSetting: GeneralSetting;
	enableEmailSetting: GeneralSetting;
	strErr = '';
	disabledFlag = false;
	loading = false;
	strMessage = '';
	editMode = false;
	visibleModify = false;
	visibleTestButton=false;

	@ViewChild('msgBox', { static: true }) msgBox: MessageBoxComponent;

	constructor(private userService: UserService, private globalService: GlobalService) { }
	ngOnInit() {
		if (Settings.getInstance().hasPrivilege('SETTINGS_EMAIL_SETTINGS', "WRITE")) {
			this.visibleModify = true;
		}
		this.visibleTestButton = Settings.getInstance().hasPrivilege('SETTINGS_EMAIL_SETTINGS_TEST', "EXECUTE");
		this.queryRecords();
	}
	queryRecords() {
		this.smtpHostSetting = Settings.getInstance().getGeneralSettingByKey('SMTPHost');
		this.smtpPortSetting = Settings.getInstance().getGeneralSettingByKey('SMTPPort');
		this.smtpUsernameSetting = Settings.getInstance().getGeneralSettingByKey('SMTPUsername');
		this.smtpPasswordSetting = Settings.getInstance().getGeneralSettingByKey('SMTPPassword');
		this.enableEmailSetting = Settings.getInstance().getGeneralSettingByKey('EnableEmail');
		if (this.smtpHostSetting === undefined || this.smtpHostSetting === null) {
			this.smtpHostSetting = new GeneralSetting();
		}
		if (this.smtpPortSetting === undefined || this.smtpPortSetting === null) {
			this.smtpPortSetting = new GeneralSetting();
		}
		if (this.smtpUsernameSetting === undefined || this.smtpUsernameSetting === null) {
			this.smtpUsernameSetting = new GeneralSetting();
		}
		if (this.smtpPasswordSetting === undefined || this.smtpPasswordSetting === null) {
			this.smtpPasswordSetting = new GeneralSetting();
		}
		if (this.enableEmailSetting === undefined || this.enableEmailSetting === null) {
			this.enableEmailSetting = new GeneralSetting();
		}
		this.valSMTPHost = this.smtpHostSetting.value;
		this.valSMTPPort = this.smtpPortSetting.value;
		this.valSMTPUsername = this.smtpUsernameSetting.value;
		this.valSMTPPassword = this.smtpPasswordSetting.value;
		if (this.enableEmailSetting.value === 'true') {
			this.valEnableEmail = true;
		} else {
			this.valEnableEmail = false;
		}
	}
	doTestConnection() {
		this.disabledFlag = true;
		this.loading = true;
		this.strErr = '';
		this.strMessage = '';
		this.userService.testEmailConnection(this.valSMTPHost, this.valSMTPPort, this.valSMTPUsername, this.valSMTPPassword, true).subscribe(
			(data) => {
				if (data === true) {
					const msg = "<mat-icon>check_circle_outline</mat-icon>";
					this.msgBox.data.message = 'Connection Successful';
					this.msgBox.data.icon = 'check_circle_outline';
					this.displaySavedMessage = true;
					this.disabledFlag = false;
					this.loading = false;
				}
				else {
					this.msgBox.data.message = 'Connection failed, please check your settings ';

					this.msgBox.data.icon = 'highlight_off';
					this.displaySavedMessage = true;
					this.disabledFlag = false;
					this.loading = false;
				}
			},
			(error) => {
				this.msgBox.data.message = 'Authentication Error - please check user name and password';
				this.msgBox.data.icon = 'highlight_off';
				this.displaySavedMessage = true;
				this.disabledFlag = false;
				this.loading = false;
			}
		);
	}
	validateRecord(): boolean {
		this.strErr = '';


		if (this.valSMTPHost === undefined || this.valSMTPHost === '' || this.valSMTPHost === null) {
			this.strErr = 'Error: SMTP Host name required';
			return false;
		}
		if (this.valSMTPPort === undefined || this.valSMTPPort === '' || this.valSMTPPort === null) {
			this.strErr = 'Error: SMTP Port required';
			return false;
		}
		if (this.valSMTPUsername === undefined || this.valSMTPUsername === '' || this.valSMTPUsername === null) {
			this.strErr = 'Error: User name required';
			return false;
		}
		if (this.valSMTPPassword === undefined || this.valSMTPPassword === '' || this.valSMTPPassword === null) {
			this.strErr = 'Error: Password required';
			return false;
		}

		return true;
	}
	doSubmit() {
		this.strErr = '';
		this.strMessage = '';
		if (!this.validateRecord()) {
			return;
		}
		this.disabledFlag = true;
		this.smtpHostSetting.key = 'SMTPHost';
		this.smtpHostSetting.value = this.valSMTPHost;
		this.userService.createUpdateSetting(this.smtpHostSetting).subscribe(
			(data1) => {
				this.smtpPortSetting.key = 'SMTPPort';
				this.smtpPortSetting.value = this.valSMTPPort;
				this.userService.createUpdateSetting(this.smtpPortSetting).subscribe(
					(data2) => {
						this.smtpUsernameSetting.key = 'SMTPUsername';
						this.smtpUsernameSetting.value = this.valSMTPUsername.toString();
						this.userService.createUpdateSetting(this.smtpUsernameSetting).subscribe(
							(data3) => {
								this.smtpPasswordSetting.key = 'SMTPPassword';
								this.smtpPasswordSetting.value = this.valSMTPPassword.toString();
								this.userService.createUpdateSetting(this.smtpPasswordSetting).subscribe(
									(data4) => {
										this.enableEmailSetting.key = 'EnableEmail';
										this.enableEmailSetting.value = this.valEnableEmail.toString();
										this.userService.createUpdateSetting(this.enableEmailSetting).subscribe(
											(data5) => {
												this.globalService.globalEvent.next('SETTINGS_REFRESH');
												this.strMessage = 'Email settings updated successfully!';
												this.disabledFlag = false;
												this.editMode = false;
											},
											(error5) => {
												this.disabledFlag = false;
											}
										);
									},
									(error4) => {
										this.disabledFlag = false;
									}
								);
							},
							(error3) => {
								this.disabledFlag = false;
							}
						);
					},
					(error2) => {
						this.disabledFlag = false;
					}
				);
			},
			(error1) => {
				this.disabledFlag = false;
			}
		);

	}
	doCancel() {
		this.queryRecords();
		this.editMode = false;
	}
	enterEditMode() {
		this.editMode = true;
		this.strMessage = '';
	}
}
